module.exports = __webpack_public_path__ + "img/Frame1321315956@2x.682d952a.png";